var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2134_7343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 3.56009C8.70314 3.56009 9.27323 2.99 9.27323 2.28676C9.27323 1.58352 8.70314 1.01343 7.9999 1.01343C7.29665 1.01343 6.72656 1.58352 6.72656 2.28676C6.72656 2.99 7.29665 3.56009 7.9999 3.56009Z",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09326 5.46672C6.09326 4.96105 6.29414 4.47608 6.65171 4.11851C7.00928 3.76094 7.49425 3.56006 7.99993 3.56006C8.50561 3.56006 8.99058 3.76094 9.34814 4.11851C9.70571 4.47608 9.90659 4.96105 9.90659 5.46672",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0934 13.74C13.7966 13.74 14.3667 13.1699 14.3667 12.4667C14.3667 11.7634 13.7966 11.1934 13.0934 11.1934C12.3902 11.1934 11.8201 11.7634 11.8201 12.4667C11.8201 13.1699 12.3902 13.74 13.0934 13.74Z",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1799 15.6533C11.1799 15.1459 11.3815 14.6592 11.7403 14.3004C12.0992 13.9416 12.5858 13.74 13.0933 13.74C13.5996 13.7418 14.0845 13.9441 14.4419 14.3027C14.7993 14.6614 14.9999 15.147 14.9999 15.6533",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90663 13.74C3.60988 13.74 4.17997 13.1699 4.17997 12.4667C4.17997 11.7634 3.60988 11.1934 2.90663 11.1934C2.20339 11.1934 1.6333 11.7634 1.6333 12.4667C1.6333 13.1699 2.20339 13.74 2.90663 13.74Z",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6533C0.999997 15.147 1.20066 14.6614 1.55804 14.3027C1.91542 13.9441 2.40038 13.7418 2.90667 13.74C3.41411 13.74 3.90078 13.9416 4.2596 14.3004C4.61842 14.6592 4.82 15.1459 4.82 15.6533",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.10669V9.28669",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45337 11.2L8.00004 9.28662L10.5467 11.2",
    stroke: "#5F488A",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2134_7343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinGroup);
export default __webpack_public_path__ + "static/media/joinGroup.7b51722c0bb86c6dbb12e3cd69c3daa4.svg";
export { ForwardRef as ReactComponent };